const getBackendUrl = () => {
  return 'https://api.mahamayafoundation.org';
};

export const SERVER_URL = getBackendUrl();
export const API_BASE_URL = `${SERVER_URL}/api/auth`;

export const getHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`
  };
};

export const getAuthHeaders = getHeaders;

export const handleResponse = async (response) => {
  if (response.status === 204) {
    return { success: true };
  }
  const contentType = response.headers.get('content-type');
  if (!contentType || !contentType.includes('application/json')) {
    const text = await response.text();
    if (!response.ok) {
      console.error('Server returned non-JSON error response:', response.status, text);
      throw new Error(text || `Server returned HTTP ${response.status} (${response.statusText || 'Error'})`);
    }
    return { success: true, message: text };
  }
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || 'Operation failed.');
  }
  return data;
};

export const getVideoUrl = (video) => {
  if (!video || !video.video_file_name) return '';
  
  let fileName = String(video.video_file_name).replace(/\\/g, '/');
  let directory = String(video.vdeo_direactory || 'Uploads').replace(/\\/g, '/');

  if (fileName.startsWith('http://') || fileName.startsWith('https://')) {
    return fileName;
  }

  if (directory.startsWith('/')) {
    directory = directory.substring(1);
  }

  if (directory.endsWith('/')) {
    directory = directory.slice(0, -1);
  }

  if (fileName.startsWith('/')) {
    fileName = fileName.substring(1);
  }

  const token = localStorage.getItem('token') || '';
  const tokenParam = token ? `?token=${encodeURIComponent(token)}` : '';

  if (fileName.includes('/') && !fileName.startsWith('http')) {
    return `${SERVER_URL}/${fileName}${tokenParam}`;
  }

  return `${SERVER_URL}/${directory}/${fileName}${tokenParam}`;
};

